const jobRoutes = {
    jobOffers: "/job-offers",
    jobOffersDuplicate: "/job-offers/duplicate",
    jobOfferAdmin: "/job-offers/:hashKey",
  };
  
  export default jobRoutes;
  